export enum PermissionType {
  Admin = 'accesso_admin',
  OfficesHierarchy = 'gerarchia_uffici',
  ExternalOrganigram = 'organigramma_esterno',
  CreateProcedure = 'crea_procedimento',
  Intermediation = 'gestione_intermediari',
  TestinAccess = 'accesso_collaudo',
  ShowDocumentalDossier = 'visualizzazione_fascicolo',
  ShowProtocolData = 'visualizza_dati_protocollo',
  ShowPhaseFilter = 'visualizza_filtro_fase',
  ShowSubprocedureState = 'visualizza_stato_endoprocedimenti',
  PDNDResidenceVerification = 'pdnd_c020_accertamento_residenza',
  PDNDAuditHistory = 'pdnd_c020_audit',
  PDNDPermissionsManagement = 'gestisci_abilitazioni_backoffice',
  CSVMassiveExtraction = 'estrazione_massiva_csv',
  ManageElectoralLists = 'gestisci_liste_elettorali',
  LegalEntitiesManagement = 'gestione_persone_giuridiche',
  ShowProcedureNumber = 'visualizza_progressivo_procedimento',
}
